export const getMenuData = [{
        title: 'Dashboard',
        key: 'ecommerceHome',
        icon: 'fe fe-home',
        roles: ['admin', 'owner'],
        url: '/',
    },
    {
        title: 'Kiwicheckout',
        key: 'kiwicheckout',
        icon: 'fe fe-layout',
        roles: ['admin', 'owner'],
        children: [{
                title: 'Produtos',
                key: 'kiwiProdutos',
                icon: 'fe fe-shopping-bag',
                roles: ['admin', 'owner'],
                url: '/ecommerce/product',
            },
            {
                title: 'Ofertas',
                key: 'kiwiOffer',
                icon: 'fe fe-layout',
                roles: ['admin', 'owner'],
                url: '/ecommerce/offer',
            },
            {
                title: 'Checkouts',
                key: 'kiwiCheckouts',
                icon: 'fe fe-shopping-cart',
                roles: ['admin', 'owner'],
                url: '/ecommerce/checkout',
            },
        ],
    },
    {
        title: 'Lojas',
        key: 'dynamicCarts',
        icon: 'fe fe-shopping-bag',
        roles: ['admin', 'owner'],
        url: '/ecommerce/carts',
    },
    {
        title: 'Pedidos',
        key: 'ecommerceOrders',
        icon: 'fe fe-box ',
        roles: ['admin', 'support', 'owner'],
        url: '/orders',
    },
    {
        title: 'Produtos',
        key: 'ecommerceOrders',
        icon: 'fe fe-shopping-cart',
        roles: ['admin', 'support', 'owner'],
        url: '/marketplace/products',
    },
    {
        title: 'Extrato',
        key: 'ecommerceExtrato',
        icon: 'fe fe-dollar-sign',
        roles: ['admin', 'owner'],
        url: '/ecommerce/balance',
    },
    {
        title: 'Webhook',
        key: 'ecommerceWebhook',
        icon: 'fe fe-radio',
        roles: ['admin', 'owner'],
        url: '/ecommerce/webhook',
    },
]